
import React, { useState, useEffect } from 'react';
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { changePassword } from '../Api/api';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    Usrname: '',
    OldPassword: '',
    NewPassword: '',
    ComShortCode: ''
  });

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    if (userData) {
      setFormData(prev => ({
        ...prev,
        Usrname: userData.Usrname || "",
        ComShortCode: userData.ComShortCode || ""
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await changePassword(formData);

      if (response && response.status === 'success') {
        if (response.message === 'Password Changed Successfully') {
          setMessage('Password changed successfully!');
          setMessageType('success');

          setFormData(prev => ({
            ...prev,
            OldPassword: '',
            NewPassword: ''
          }));
        }
        else if (response.message === 'Old Password Is Incorrect') {
          setMessage('Old password is incorrect');
          setMessageType('danger');
        }
        else {
          setMessage(response.message || 'Password change failed');
          setMessageType('danger');
        }
      } else {
        setMessage('Password change failed');
        setMessageType('danger');
      }

    } catch (error) {
      console.error('Error changing password:', error);
      setMessage('An error occurred while changing password');
      setMessageType('danger');
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f6f9' }}>
      
      <Sidebar currentPage="changepassword" />

      <div style={{ flex: 1 }}>
        <Header title="Change Password" />

        <div style={{ padding: '30px' }}>

          <div style={{
            maxWidth: '480px',
            margin: '40px auto',
            background: '#fff',
            padding: '35px',
            borderRadius: '12px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.08)'
          }}>

            <h3 style={{
              textAlign: 'center',
              marginBottom: '25px',
              fontWeight: '600',
              color: '#2c3e50'
            }}>
              Change Password
            </h3>

            {message && (
              <div className={`alert alert-${messageType}`} style={{ marginBottom: '20px' }}>
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit}>

              {/* Username */}
              <div className="mb-3">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control"
                  name="Usrname"
                  value={formData.Usrname}
                  disabled
                />
              </div>

              {/* Old Password */}
              <div className="mb-3">
                <label className="form-label">Old Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="OldPassword"
                  value={formData.OldPassword}
                  onChange={handleChange}
                  required
                  placeholder="Enter old password"
                />
              </div>

              {/* New Password */}
              <div className="mb-3" style={{ position: "relative" }}>
                <label className="form-label">New Password</label>

                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-control"
                  name="NewPassword"
                  value={formData.NewPassword}
                  onChange={handleChange}
                  required
                  placeholder="Enter new password"
                />

                <span
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "38px",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#6c757d"
                  }}
                >
                  {showNewPassword ? "🙈" : "👁"}
                </span>
              </div>

              {/* Buttons */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '12px',
                marginTop: '25px'
              }}>

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ minWidth: "150px" }}
                >
                  Change Password
                </button>

                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => navigate('/dashboard')}
                >
                  Back
                </button>

              </div>

            </form>

          </div>

        </div>
      </div>
    </div>
  );
};

export default ChangePassword;



// import React, { useState } from 'react';
// import Sidebar from "../components/Sidebar";
// import Header from "../components/Header";
// import { changePassword } from '../Api/api';
// import { useNavigate } from 'react-router-dom';

// const ChangePassword = () => {
//   const [formData, setFormData] = useState({
//     Usrname: '',
//     OldPassword: '',
//     NewPassword: '',
//     ComShortCode: ''
//   });
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');
//   const navigate = useNavigate();

//   // Get username from local storage
// React.useEffect(() => {
//   const userData = JSON.parse(localStorage.getItem('userData') || '{}');

//   if (userData) {
//     const comShortCode = userData.ComShortCode || "";

//     setFormData(prev => ({
//       ...prev,
//       Usrname: userData.Usrname || "",
//       ComShortCode: comShortCode
//     }));
//   }
// }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     try {
//       const response = await changePassword(formData);
      
//       if (response && response.status === 'success') {
//   if (response.message === 'Password Changed Successfully') {
//     setMessage('Password changed successfully!');
//     setMessageType('success');
//     setFormData(prev => ({
//       ...prev,
//       OldPassword: '',
//       NewPassword: ''
//     }));
//   } 
//   else if (response.message === 'Old Password Is Incorrect') {
//     setMessage('Old password is incorrect');
//     setMessageType('danger');   // ✅ change here
//   } 
//   else {
//     setMessage(response.message || 'Password change failed');
//     setMessageType('danger');   // ✅ change here
//   }
// } else {
//   setMessage('Password change failed');
//   setMessageType('danger');     // ✅ change here
// }
//     } catch (error) {
//   console.error('Error changing password:', error);
//   setMessage('An error occurred while changing password');
//   setMessageType('danger');
// }
//   };

//   const containerStyle = {
//     display: 'flex',
//     minHeight: '100vh',
//     backgroundColor: '#f5f6f8'
//   };

//   const contentStyle = {
//     flex: 1,
//     marginLeft: '0',
//     padding: '20px',
//     transition: 'margin-left 0.3s ease'
//   };

//   const formContainerStyle = {
//     maxWidth: '500px',
//     margin: '40px auto',
//     backgroundColor: '#fff',
//     padding: '30px',
//     borderRadius: '8px',
//     boxShadow: '0 2px 15px rgba(0,0,0,0.1)'
//   };

//   const titleStyle = {
//     color: '#2c3e50',
//     marginBottom: '24px',
//     textAlign: 'center',
//     fontSize: '24px',
//     fontWeight: '600'
//   };

//   const buttonStyle = {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'center',
//     marginTop: '24px'
//   };

//   return (
//     <div style={containerStyle}>
//       <Sidebar currentPage="changepassword" />
//       <div style={{ flex: 1 }}>
//         <Header title="Change Password" />
//         <div style={contentStyle}>
//           <div style={formContainerStyle}>
//             <h2 style={titleStyle}>Change Password</h2>
            
//             {message && (
//               <div className={`alert alert-${messageType}`} style={{ marginBottom: '20px' }}>
//                 {message}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>
//               <div className="mb-3">
//                 <label className="form-label">Username</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="Usrname"
//                   value={formData.Usrname}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter username"
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Old Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   name="OldPassword"
//                   value={formData.OldPassword}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter old password"
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">New Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   name="NewPassword"
//                   value={formData.NewPassword}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter new password"
//                 />
//               </div>

//               <div style={buttonStyle}>
//                 <button type="submit" className="btn btn-primary">
//                   Change Password
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => navigate('/dashboard')}
//                 >
//                   Back to Dashboard
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;